module.exports = __webpack_public_path__ + "static/img/pageFour.6133038.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pageFour.png
// module id = 2Wt2
// module chunks = 1